import { useStore } from '@stores';
import { useEffect } from 'react';

declare const abp: any;

/**
 * Tenant profile for `id` (defaults to the logged in tenant).
 * The profile stays in the store and is only fetched when the loaded one does not
 * match the requested id, so the own profile is loaded once per session, while the
 * host admin can still open other tenants. A non-matching (stale) profile is never returned.
 */
export const useTenantProfile = (id: number | undefined = abp.session.tenantId) => {
  const { tenantProfileStore } = useStore();
  const { tenantProfile: loaded, loading } = tenantProfileStore;

  // The API looks the profile up by TenantId, so `id` is a tenant id (not the profile's own id).
  const matches = !!id && loaded?.tenantId === id;

  useEffect(() => {
    if (id && !matches) {
      tenantProfileStore.getProfile({ id });
    }
  }, [tenantProfileStore, id, matches]);

  return { tenantProfile: matches ? loaded : undefined, loading };
};
